'use strict';

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _matrixJsSdk = require('matrix-js-sdk');

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _Modal = require('../../../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _languageHandler = require('../../../languageHandler');

var _GroupStore = require('../../../stores/GroupStore');

var _GroupStore2 = _interopRequireDefault(_GroupStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2017 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

module.exports = _react2.default.createClass({
    displayName: 'GroupRoomInfo',

    contextTypes: {
        matrixClient: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixClient)
    },

    propTypes: {
        groupId: _propTypes2.default.string,
        groupRoomId: _propTypes2.default.string
    },

    getInitialState: function getInitialState() {
        return {
            isUserPrivilegedInGroup: null,
            groupRoom: null,
            groupRoomPublicityLoading: false,
            groupRoomRemoveLoading: false
        };
    },

    componentWillMount: function componentWillMount() {
        this._initGroupStore(this.props.groupId);
    },

    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
        if (newProps.groupId !== this.props.groupId) {
            this._unregisterGroupStore(this.props.groupId);
            this._initGroupStore(newProps.groupId);
        }
    },
    componentWillUnmount: function componentWillUnmount() {
        this._unregisterGroupStore(this.props.groupId);
    },
    _initGroupStore: function _initGroupStore(groupId) {
        _GroupStore2.default.registerListener(groupId, this.onGroupStoreUpdated);
    },
    _unregisterGroupStore: function _unregisterGroupStore(groupId) {
        _GroupStore2.default.unregisterListener(this.onGroupStoreUpdated);
    },
    _updateGroupRoom: function _updateGroupRoom() {
        var _this = this;

        this.setState({
            groupRoom: _GroupStore2.default.getGroupRooms(this.props.groupId).find(function (r) {
                return r.roomId === _this.props.groupRoomId;
            })
        });
    },


    onGroupStoreUpdated: function onGroupStoreUpdated() {
        this.setState({
            isUserPrivilegedInGroup: _GroupStore2.default.isUserPrivileged(this.props.groupId)
        });
        this._updateGroupRoom();
    },

    _onRemove: function _onRemove(e) {
        var _this2 = this;

        var groupId = this.props.groupId;
        var roomName = this.state.groupRoom.displayname;
        e.preventDefault();
        e.stopPropagation();
        var QuestionDialog = _index2.default.getComponent("dialogs.QuestionDialog");
        _Modal2.default.createTrackedDialog('Confirm removal of group from room', '', QuestionDialog, {
            title: (0, _languageHandler._t)("Are you sure you want to remove '%(roomName)s' from %(groupId)s?", { roomName: roomName, groupId: groupId }),
            description: (0, _languageHandler._t)("Removing a room from the community will also remove it from the community page."),
            button: (0, _languageHandler._t)("Remove"),
            onFinished: function onFinished(proceed) {
                if (!proceed) return;
                _this2.setState({ groupRoomRemoveLoading: true });
                var groupId = _this2.props.groupId;
                var roomId = _this2.props.groupRoomId;
                _GroupStore2.default.removeRoomFromGroup(_this2.props.groupId, roomId).then(function () {
                    _dispatcher2.default.dispatch({
                        action: "view_group_room_list"
                    });
                }).catch(function (err) {
                    console.error('Error whilst removing ' + roomId + ' from ' + groupId, err);
                    var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
                    _Modal2.default.createTrackedDialog('Failed to remove room from group', '', ErrorDialog, {
                        title: (0, _languageHandler._t)("Failed to remove room from community"),
                        description: (0, _languageHandler._t)("Failed to remove '%(roomName)s' from %(groupId)s", { groupId: groupId, roomName: roomName })
                    });
                }).finally(function () {
                    _this2.setState({ groupRoomRemoveLoading: false });
                });
            }
        });
    },

    _onCancel: function _onCancel(e) {
        _dispatcher2.default.dispatch({
            action: "view_group_room_list"
        });
    },

    _changeGroupRoomPublicity: function _changeGroupRoomPublicity(e) {
        var _this3 = this;

        var isPublic = e.target.value === "public";
        this.setState({
            groupRoomPublicityLoading: true
        });
        var groupId = this.props.groupId;
        var roomId = this.props.groupRoomId;
        var roomName = this.state.groupRoom.displayname;
        _GroupStore2.default.updateGroupRoomVisibility(this.props.groupId, roomId, isPublic).catch(function (err) {
            console.error('Error whilst changing visibility of ' + roomId + ' in ' + groupId + ' to ' + isPublic, err);
            var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
            _Modal2.default.createTrackedDialog('Failed to remove room from group', '', ErrorDialog, {
                title: (0, _languageHandler._t)("Something went wrong!"),
                description: (0, _languageHandler._t)("The visibility of '%(roomName)s' in %(groupId)s could not be updated.", { roomName: roomName, groupId: groupId })
            });
        }).finally(function () {
            _this3.setState({
                groupRoomPublicityLoading: false
            });
        });
    },


    render: function render() {
        var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');
        var InlineSpinner = _index2.default.getComponent('elements.InlineSpinner');
        var GeminiScrollbarWrapper = _index2.default.getComponent("elements.GeminiScrollbarWrapper");
        if (this.state.groupRoomRemoveLoading || !this.state.groupRoom) {
            var Spinner = _index2.default.getComponent("elements.Spinner");
            return _react2.default.createElement(
                'div',
                { className: 'mx_MemberInfo' },
                _react2.default.createElement(Spinner, null)
            );
        }

        var adminTools = void 0;
        if (this.state.isUserPrivilegedInGroup) {
            adminTools = _react2.default.createElement(
                'div',
                { className: 'mx_MemberInfo_adminTools' },
                _react2.default.createElement(
                    'h3',
                    null,
                    (0, _languageHandler._t)("Admin Tools")
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_MemberInfo_buttons' },
                    _react2.default.createElement(
                        AccessibleButton,
                        { className: 'mx_MemberInfo_field', onClick: this._onRemove },
                        (0, _languageHandler._t)('Remove from community')
                    )
                ),
                _react2.default.createElement(
                    'h3',
                    null,
                    (0, _languageHandler._t)('Visibility in Room List'),
                    this.state.groupRoomPublicityLoading ? _react2.default.createElement(InlineSpinner, null) : _react2.default.createElement('div', null)
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', { type: 'radio',
                            value: 'public',
                            checked: this.state.groupRoom.isPublic,
                            onClick: this._changeGroupRoomPublicity
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'mx_MemberInfo_label_text' },
                            (0, _languageHandler._t)('Visible to everyone')
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', { type: 'radio',
                            value: 'private',
                            checked: !this.state.groupRoom.isPublic,
                            onClick: this._changeGroupRoomPublicity
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'mx_MemberInfo_label_text' },
                            (0, _languageHandler._t)('Only visible to community members')
                        )
                    )
                )
            );
        }

        var avatarUrl = this.state.groupRoom.avatarUrl;
        var avatarElement = void 0;
        if (avatarUrl) {
            var httpUrl = this.context.matrixClient.mxcUrlToHttp(avatarUrl, 800, 800);
            avatarElement = _react2.default.createElement(
                'div',
                { className: 'mx_MemberInfo_avatar' },
                _react2.default.createElement('img', { src: httpUrl })
            );
        }

        var groupRoomName = this.state.groupRoom.displayname;
        return _react2.default.createElement(
            'div',
            { className: 'mx_MemberInfo' },
            _react2.default.createElement(
                GeminiScrollbarWrapper,
                { autoshow: true },
                _react2.default.createElement(
                    AccessibleButton,
                    { className: 'mx_MemberInfo_cancel', onClick: this._onCancel },
                    _react2.default.createElement('img', { src: require("../../../../res/img/cancel.svg"), width: '18', height: '18', className: 'mx_filterFlipColor' })
                ),
                avatarElement,
                _react2.default.createElement(
                    'h2',
                    null,
                    groupRoomName
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_MemberInfo_profile' },
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_MemberInfo_profileField' },
                        this.state.groupRoom.canonical_alias
                    )
                ),
                adminTools
            )
        );
    }
});
//# sourceMappingURL=GroupRoomInfo.js.map